import React from 'react'
import { Route } from 'react-router'
import * as Views from './views'
import { getCurrentCommunity, isPartnerRegisterEnabled } from 'utils'

const community = getCurrentCommunity()

// Redirect users to the appropriate dashboard if already authenticated in a portal
const redirectIfPortalToken = (_, replace) => {
  const storage = window && window.localStorage
  if (!storage) return

  if (storage.getItem('artist-portal-token')) {
    replace('/artist-portal/dashboard')
    return
  }
  if (storage.getItem('partner-portal-token')) {
    replace('/partner-portal/dashboard')
    return
  }
  if (storage.getItem('school_portal_token')) {
    replace('/school-portal/dashboard')
  }
}

const Routes = (
  <Route onEnter={redirectIfPortalToken}>
    <Route path="sign-in" component={Views.SignIn} />
    <Route path="sign-in/forgot-password" component={Views.ForgotPassword} />
    <Route
      path="sign-in/forgot-password-confirmation"
      component={Views.ForgotPasswordConfirmation}
    />
    <Route
      path="sign-in/reset-password/:token"
      component={Views.ResetPassword}
    />
    <Route exact path="sign-in/claim-account" component={Views.ClaimAccount} />
    <Route
      path="sign-in/claim-account/:token"
      component={Views.ClaimAccountPassword}
    />
    <Route
      path="sign-in/claim-account-confirmation"
      component={Views.ClaimAccountConfirmation}
    />
    {isPartnerRegisterEnabled(community) && (
      <Route path="sign-in/register" component={Views.Register} />
    )}
    <Route
      path="sign-in/account-pending-confirmation"
      component={Views.AccountPendingConfirmation}
    />
    <Route path="sign-in/account-not-found" component={Views.AccountNotFound} />
    <Route path="sign-in/select-employer" component={Views.SelectEmployer} />
    <Route path="sign-in/sso-redirect" component={Views.SsoRedirect} />
  </Route>
)

export default Routes
